export default () => {
  Alpine.data('currencySwitcher', (eurExchangeRate, gbpExchangeRate, enableState) => {
    return {
      userCurrency: enableState ? (localStorage.getItem('userCurrency') || 'EUR') : 'EUR',
      currencySet: enableState ? (localStorage.getItem('userCurrency') || false) : true,
      eurExchangeRate: parseFloat(eurExchangeRate),
      gbpExchangeRate: parseFloat(gbpExchangeRate),
      currencies: ['USD', 'EUR', 'GBP'],
      dropdownOpen: false,
      init() {
        if (!this.currencySet) {
          this.setUserCurrencyBasedOnLocation();
        }
      },
      setUserCurrencyBasedOnLocation() {
        const timestamp = Math.floor(Date.now() / 1000);
        fetch('/wp-json/user/v1/currency?timestamp=' + timestamp)
          .then(response => response.json())
          .then(data => {
            this.userCurrency = data.currency || 'EUR';
            localStorage.setItem('userCurrency', this.userCurrency);
            this.currencySet = true;
            window.dispatchEvent(new CustomEvent('currency-updated'));
          })
          .catch(error => {
            console.error('Error fetching location data:', error);
          });
      },
      convertCurrencyString(string, value) {
        if (!string || !value) return null;

        if ( enableState === false ) {
          return string + value;
        }

        const num = parseFloat(value);
        let converted = num;
        let baseCurrency = 'EUR';

        // Determine base currency based on symbol
        if (string.includes('£')) baseCurrency = 'GBP';
        else if (string.includes('$')) baseCurrency = 'USD';
        else baseCurrency = 'EUR';

        // Convert based on detected baseCurrency and userCurrency
        if (baseCurrency === this.userCurrency) {
          return string + Math.ceil(converted);
        }

        if (baseCurrency === 'EUR') {
          if (this.userCurrency === 'GBP') {
            converted = num * (this.gbpExchangeRate / this.eurExchangeRate);
            string = string.replace('€', '£');
          } else if (this.userCurrency === 'USD') {
            converted = num / this.eurExchangeRate;
            string = string.replace('€', '$');
          }
        } else if (baseCurrency === 'GBP') {
          if (this.userCurrency === 'EUR') {
            converted = num * (this.eurExchangeRate / this.gbpExchangeRate);
            string = string.replace('£', '€');
          } else if (this.userCurrency === 'USD') {
            converted = num / this.gbpExchangeRate;
            string = string.replace('£', '$');
          }
        } else if (baseCurrency === 'USD') {
          if (this.userCurrency === 'EUR') {
            converted = num * this.eurExchangeRate;
            string = string.replace('$', '€');
          } else if (this.userCurrency === 'GBP') {
            converted = num * this.gbpExchangeRate;
            string = string.replace('$', '£');
          }
        }

        return string + Math.ceil(converted);
      },
      selectCurrency(currency) {
        if (enableState === false) return currency;

        this.userCurrency = currency;
        localStorage.setItem('userCurrency', currency);
        this.currencySet = true;
        this.dropdownOpen = false;
        window.dispatchEvent(new CustomEvent('currency-updated'));
      }
    };
  });
}
